import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
	title: {
		color: "#393762",
		lineHeight: "0.9",
		letterSpacing: "-0.66px",
	},
	container: {
		margin: "auto",
		textAlign: "center",
		width: "50%",
		padding: "10px",
	},
	field: {
		width: "300px",
		fontSize: "300px",
	},
	error: {
		color: "#ff3b30",
		fontSize: "13px",
	},
	icon: {
		cursor: "pointer",
		color: "#3689ea",
		transform: "scale(2)",
	},
	message: {
		color: "rgba(71, 71, 71, 0.3)",

		paddingBottom: 10,
	},
	link: {
		color: "#3689ea",
		lineHeight: "0.9",
		letterSpacing: "-0.66px",
		marginTop: "1000px",
	},
}));
